import { createSelector } from 'reselect';
import User from '../entities/user';

export const getRawUsers = state => state.users;

export const getUsers = createSelector(
	[ getRawUsers ],
	users => users.map( user => User.fromJSON( user ) )
);
